// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1_gNG","buttons":"SendReceipts_buttons__Ofh1I","email":"SendReceipts_email__3o9tz","bookApptTitle":"SendReceipts_bookApptTitle__3Vyc3"};